import { Component, OnInit, ViewChild, NgModule, ViewChildren, NgZone} from '@angular/core';
import { CanActivate, Router } from "@angular/router";
import { AuthService } from '../../services/auth.service';
import * as firebase from 'firebase';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {google} from 'googleapis'
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
  
  
})


export class AdminComponent implements OnInit{


  constructor(private authService: AuthService,
              private router: Router,
              private formBuilder: FormBuilder,
              private _renderer2: Renderer2, 
              @Inject(DOCUMENT) private _document: Document) { }

  admin: any;
  userList = []
  inactiveList = []
  devList = [] 
  marketingList = []
  operationList = []
  prodList = []
  adminList = []
  modify: any
  modifForm: FormGroup;

  ngOnInit(): void {
    this.authService.isAdmin()
    .then((admin)=>{ 
      this.admin = admin 
      localStorage.setItem('page','Admin')
    })
    .then((admin)=>{
      if(this.admin ==! true)  {
        this.router.navigate(['/home']);
      }
      }).then(()=>{
        this.getList();

    })

  }

  setInactive(user:string) {
    firebase.database().ref('users/' + user).update({
      actif : false
    }).then(()=>{
      firebase.database().ref('users/' + user).on('value', (snapshot)=>{
        var service = snapshot.val().service;
        firebase.database().ref('service/' + service + '/' + user).update({
          actif : false
        })
      })
      this.getList();
    });
    
  }

  setActive(user:string) {
    firebase.database().ref('users/' + user).update({
      actif : true
    }).then(()=>{
      firebase.database().ref('users/' + user).on('value', (snapshot)=>{
        var service = snapshot.val().service;
        firebase.database().ref('service/' + service + '/' + user).update({
          actif : true
        })
      })
      this.getList();
    });
    
  }

  getList(){
    this.userList = []
    this.inactiveList= []
    this.devList = []
    this.marketingList = []
    this.operationList = []
    this.prodList = []
    this.adminList = []
    var ref = firebase.database().ref("users");
    ref.orderByKey().on("child_added", (snapshot) => {
        var name = snapshot.val().name;
        var email = snapshot.val().email;
        var id = snapshot.key;
        var service = snapshot.val().service;
        var profil = snapshot.val().profil;
        var push = {name: name, email : email, id : id, service : service, profil : profil}
      if(snapshot.val().actif == true){
        this.userList.push(push)
      }else{
        this.inactiveList.push(push)
      }
    });

    var ref = firebase.database().ref("service/Dev");
    
    ref.orderByKey().on("child_added", (snapshot) => {
      var name = snapshot.val().mail;
      if(snapshot.val().actif == true){
        var push = {name: name}
        this.devList.push(push)
      }
    });

    var ref = firebase.database().ref("service/Marketing");
   
    ref.orderByKey().on("child_added", (snapshot) => {
      var name = snapshot.val().mail;
      if(snapshot.val().actif == true){
        var push = {name: name}
      this.marketingList.push(push)
      }
    });

    var ref = firebase.database().ref("service/Operation");
    
    ref.orderByKey().on("child_added", (snapshot) => {
      var name = snapshot.val().mail;
      if(snapshot.val().actif == true){
      var push = {name: name}
      this.operationList.push(push)
      }
    });

    var ref = firebase.database().ref("Profil/admin");
    ref.orderByKey().on("child_added", (snapshot) => {
      var name = snapshot.val().mail;
      var actif = snapshot.val().actif
      if(actif ==true){
        var push = {name: name}
        this.adminList.push(push)
      }
    });

    var ref = firebase.database().ref("Prod");
    ref.orderByKey().on("child_added", (snapshot) => {
      var name = snapshot.val().mail;
      if(snapshot.val().actif == true){
      var push = {name: name}
      this.prodList.push(push)
      }
    });

  }


  showModif(user:string){
    if(this.modify == user){
      this.modify = null
    }else{
      this.modify = user;
      this.initForm(user);
    }
  }

  initForm(user:string){
    firebase.database().ref('users/' + user).on('value', (snapshot)=>{
      var name = snapshot.val().name;
      var service = snapshot.val().service
      var profil = snapshot.val().profil
      this.modifForm = this.formBuilder.group({
        name: [name, [Validators.required]],
        service: [service, [Validators.required]],
        profil: [profil, [Validators.required]]
      });
    })
   
  }

  sendModif(user:string, service: string, mail:string, profil:string){
    const name = this.modifForm.get('name').value;
    const newService = this.modifForm.get('service').value;
    const newProfil = this.modifForm.get('profil').value;
    firebase.database().ref('users/' + user).update({
      name : name,
      service : newService,
      profil : newProfil
    })
    .then(()=>{
      firebase.database().ref('service/' + service + '/' + user).remove();
      firebase.database().ref('service/' + newService + '/' + user).set({
          actif : true,
          mail : mail
        })
      }).then(()=>{
        firebase.database().ref('Profil/' + profil + '/' + user).remove();
        firebase.database().ref('Profil/' + newProfil + '/' + user).set({
          actif : true,
          mail : mail
        }).then(()=>{
          this.modify = null
          this.getList();
        })
      })   
  }
  
}
